import axios from 'axios'

import { rootStore } from '../provider/StoreProvider'

axios.defaults.baseURL = process.env.REACT_APP_STO_API

export const HttpReq = async <T>({
  method,
  url,
  data,
  isLoadable = true,
}: {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  url: string
  data?: Record<string, any>
  isLoadable?: boolean
}): Promise<T> => {
  if (process.env.NODE_ENV === 'development') {
    console.count(`http call ${url}`)
  }
  try {
    const httpRequest = async () => {
      switch (method) {
        case 'GET':
          return await axios.get<T>(url, { params: data, withCredentials: true })
        case 'POST':
          isLoadable && rootStore.commonStore.setIsLoading(true)
          return await axios.post<T>(url, data, { withCredentials: true })
        case 'PUT':
          isLoadable && rootStore.commonStore.setIsLoading(true)
          return await axios.put<T>(url, data, { withCredentials: true })
        case 'DELETE':
          isLoadable && rootStore.commonStore.setIsLoading(true)
          return await axios.delete<T>(url, { data: data, withCredentials: true })
      }
    }
    const response = await httpRequest()
    return response.data
  } catch (error) {
    if (axios.isAxiosError<{ message: string; CODE: string }>(error)) {
      if (process.env.NODE_ENV === 'development') {
        console.log('error: ', { error })
      }
      if (error.response?.data?.CODE === 'API_001401') {
        rootStore.authStore.resetUserInfo()
      }
    }
    throw error
  } finally {
    isLoadable && rootStore.commonStore.setIsLoading(false)
  }
}
